import { faClockRotateLeft, faFileInvoice, faHandHoldingDollar, faHome, faRepeat, faUser } from '@fortawesome/free-solid-svg-icons';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import { Button } from 'components/button';
import { LanguageSwitcher } from 'components/language-switcher';
import LocaleLink from 'components/link/LocaleLink';
import { useSelector } from 'hooks';
import { useI18n } from 'locales';
import PropTypes from 'prop-types';
import { shallowEqual } from 'react-redux';

const routes = [
  {
    path: '/dashboard',
    label: 'Overview',
    icon: faHome,
  },
  {
    path: '/give',
    label: 'Giving',
    icon: faHandHoldingDollar,
  },
  {
    path: '/history',
    label: 'History',
    icon: faClockRotateLeft,
  },
  {
    path: '/subscriptions',
    label: 'Planned Christian Giving',
    icon: faRepeat,
  },
  {
    path: '/receipts',
    label: 'Tax Receipts',
    icon: faFileInvoice,
  },
  {
    path: '/profile',
    label: 'Profile',
    icon: faUser,
  },
];

const selector = (state) => ({
  currentInfo: state.currentInfo,
});

function NavMenu({ pathname, isMobile }) {
  const { currentInfo } = useSelector(selector, shallowEqual);
  const t = useI18n();

  return !currentInfo.dataFetched ? (
    <Stack direction='row' spacing={1} sx={{ my: 2, justifyContent: 'center', backgroundColor: 'transparent' }}>
      <CircularProgress />
    </Stack>
  ) : (
    <>
      <Stack sx={{ mb: 2, display: isMobile ? 'none' : 'block' }}>
        <LanguageSwitcher size="small" />
      </Stack>
      {routes.map((route, index) => {
        return (
          <LocaleLink
            key={`nav-item-${index}`}
            to={route.path}
          >
            <Button
              label={t(route.label)}
              leading={route.icon}
              variant={pathname.startsWith(route.path) ? 'menu-active' : 'menu'}
              sx={{
                borderRadius: '10px',
                textAlign: 'left',
              }}
            />
          </LocaleLink>
        );
      })}
    </>
  );
}

NavMenu.propTypes = {
  pathname: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default NavMenu;
